const VocabGeneralDisplay = {
  'birthday' : ['Nacimiento', 'Birthday'],
  'birthplace' : ['Lugar de nacimiento', 'Birthplace'],
  'biological_sex': ['Sexo al nacer', 'Sex at birth'],
  'sex': ['Sexo', 'Sex'],
  'height' : ['Altura', 'height'],
  'weight' : ['Peso', 'Weight'],
  'marital_status' : ['Estado civil', 'Marital status'],
  'education' : ['Escolaridad', 'Scholarship'],
  'occupation' : ['Ocupación', 'Occupation'],
  'religion' : ['Religión', 'Religion'],
  'loading_data' : ['Recuperando informacion general...', 'Loading general information...'],
}
export default VocabGeneralDisplay;
  